export default {
      id: "ic-close-or-delete-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic-close-or-delete-usage",
      toString: function () {
        return this.url;
      }
    }